import React, { useEffect } from "react";
import AppDialog from "@/components/common/AppDialog";
import { useTran } from "@/hooks";

const ThankYouModal = ({ open, onClose }) => {
  const { t } = useTran();

  useEffect(() => {
    if (!open) return;
    const timer = setTimeout(() => onClose(), 5000);
    return () => clearTimeout(timer);
  }, [open]);

  return (
    <AppDialog
      open={open}
      onOpenChange={onClose}
      size="sm"
      hideCloseButton={false}
      contentClassName="!p-0 overflow-hidden"
      headerWrapperClassName="hidden"
      bodyClassName="!py-0 !px-0"
    >
      <div className="flex flex-col items-center gap-5 px-8 py-10 text-center">
        {/* ── Logo ── */}
        <img
          src="/logos/logo.svg"
          alt={t("NxStart Logo")}
          className="h-10 w-auto sm:h-11"
        />

        {/* ── Divider ── */}
        <div className="w-full h-px bg-gray-100 dark:bg-gray-700" />

        {/* ── Envelope SVG ── */}
        <div
          className="w-28 h-28 rounded-full flex items-center justify-center
                     bg-blue-50 dark:bg-blue-900/20"
        >
          <svg
            viewBox="0 0 80 80"
            fill="none"
            className="w-20 h-20"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* Envelope body */}
            <rect
              x="8"
              y="22"
              width="64"
              height="42"
              rx="5"
              fill="#E8EEFF"
              stroke="#6B7FD7"
              strokeWidth="2"
            />
            {/* Envelope flap */}
            <path
              d="M8 27l32 22 32-22"
              stroke="#6B7FD7"
              strokeWidth="2"
              fill="none"
            />
            {/* Check circle */}
            <circle cx="57" cy="23" r="13" fill="#4F5FD4" />
            <path
              d="M51 23l4.5 4.5 8-8"
              stroke="white"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        {/* ── Text ── */}
        <div className="space-y-2">
          <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
            {t(
              "Thank you. Your submission has been received. A confirmation copy has also been sent to your email. We will contact you by email if updates are made or if follow-up is necessary.",
            )}
          </p>
        </div>

        {/* ── Progress Bar ── */}
        {open && (
          <div className="w-full h-1 bg-gray-100 dark:bg-gray-700 rounded-full overflow-hidden">
            <div
              className="h-full bg-blue-500 rounded-full"
              style={{ animation: "cfh-shrink 5s linear forwards" }}
            />
          </div>
        )}
      </div>

      {/* Shrink keyframe */}
      <style>{`
        @keyframes cfh-shrink {
          from { width: 100%; }
          to   { width: 0%; }
        }
      `}</style>
    </AppDialog>
  );
};

export default ThankYouModal;
